/** A card's picture: a hexagon tile as the buttons draw it (ui/art/hexArt.ts), a machine perhaps on it. */
import type { JSX } from 'react';

import { hexArt, type HexLook } from '@ui/art/hexArt';

import './cards.css';

export function HexPicture({ look }: { look: HexLook }): JSX.Element {
  return (
    <svg
      className="hex-pic"
      viewBox="-40 -44 80 88"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: hexArt(look) }}
    />
  );
}
